import { useNavigate } from "react-router-dom";
import { useTalent } from "../../actions/homeActions";
import { useAuth } from "../../context/authContext";
import { useSelector } from "react-redux";
export default () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const userData = useSelector((state) => state.app.userData.userData);

  const { data: talentList, isLoading, isError, error } = useTalent(true, 1);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading talent: {error.message}</p>
      </div>
    );
  }
  const handleTalent = (id) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate(`/talent/${id}`);
    }
  };

  const settings = {
    dots: false,
    infinite: talentList?.talent?.length > 4,
    slidesToShow:
      talentList?.talent?.length >= 4 ? 4 : talentList?.talent?.length,
    slidesToScroll: 1,
    autoplay: talentList?.talent?.length > 4,
    // autoplay: false,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    centerMode: false,
    variableWidth: false,
    className: talentList?.talent?.length >= 4 ? "" : "sm:px-5 xl:px-10",
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow:
            talentList?.talent?.length >= 2 ? 2 : talentList?.talent?.length,
          slidesToScroll: 1,
          cssEase: "linear",
          pauseOnHover: true,
          infinite: talentList?.talent?.length > 2,
          autoplay: talentList?.talent?.length > 2,
          centerMode: false,
          variableWidth: false,
          className: talentList?.talent?.length === 1 ? "xs:px-3" : "",
        },
      },
    ],
  };
  return { isLoading, talentList, handleTalent, settings };
};
